module.exports = __webpack_public_path__ + "static/media/Roshnai.9af06730.jpg";